import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { SCRAPED_PRODUCT_KEY } from "./keys";

import { ScrapedProductRepository } from "@/repositories/scraped-product";
import { AddProduct } from "@/types";

export const useImportScrapedProduct = () => {
  const scrapedProductRepository = useRef(new ScrapedProductRepository());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: AddProduct }) => {
      return await scrapedProductRepository.current.import(id, data);
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        predicate: (q) => {
          if (q.queryKey[0] === SCRAPED_PRODUCT_KEY) {
            return true;
          }

          return false;
        },
      });
    },
  });
};
